// extracted by mini-css-extract-plugin
export default {"dietPickerButtonGrid":"dietPickerButtonGrid_dietPickerButtonGrid__8KTCk"};